<template>
  <!-- 题库管理 -->
    <div class="supervise lesson-tab-box">
    <div class="right-btn">
      <el-button class="add-lesson-btn" type="primary" icon="el-icon-plus" @click="handleAddEtfield">新增题库</el-button>
    </div>
        <el-tabs v-model="activeName" @tab-click="tabClick">
            <el-tab-pane label="我的题库" name="mysupervise" class="mysupervise">
                <is-empty :show="etfieldList.length > 0" message="暂无题库~">
                    <el-row :gutter="20" class="supervise-box" v-for="etfield in etfieldList" :key="etfield.fieldId">
                        <el-col :span="3">
                            <div class="supervise-tag">
                                <span v-text="etfield.questionNum"></span>道题
                            </div>
                        </el-col>
                        <el-col :span="15">
                            <div class="supervise-contant">
                                <div>
                                    <span v-text="etfield.fieldName"></span>
                                </div>
                                <div>
                                    创建时间：<span v-text="etfield.createTime"></span>
                                </div>
                                <div>
                                    描述：<span v-text="etfield.memo || '-'"></span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="top">
                                <el-dropdown trigger="click" @command="handleCommand($event, etfield)">
                                    <span class="el-dropdown-link">
                                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="edit"><i class="el-icon-edit"></i>编辑</el-dropdown-item>
                                        <el-dropdown-item command="del"><i class="el-icon-delete"></i>删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="bottom">
                                <!-- <el-button type="primary" size="small" plain>练习</el-button> -->
                                <el-button type="primary" size="small" @click="$router.push({ name: 'questionList', params: { fieldId: etfield.fieldId } })" plain>
                                    进入题库<i class="el-icon-right"></i>
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <br>
                    <el-pagination layout="total, sizes, prev, pager, next, jumper"
                        background
                        :current-page="currentPage"
                        :page-size="pageSize"
                        :pager-count="pagerCount"
                        :total="totalEnclosure"
                        @size-change="sizeChange"
                        @current-change="currentChange">
                    </el-pagination>
                </is-empty>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="`${form.fieldId ? '编辑' : '新增'}题库`" :visible.sync="open" width="720px">
            <el-form label-width="80px" :model="form" :rules="rules">
                <el-form-item label="题库名称" prop="fieldName">
                    <el-input placeholder="请输入题库名称" v-model="form.fieldName"></el-input>
                </el-form-item>
                <el-form-item label="题库编号" prop="code">
                    <el-input placeholder="请输入题库编号" v-model="form.code"></el-input>
                </el-form-item>
                <el-form-item label="题库描述">
                    <el-input type="textarea" placeholder="请输入题库描述" :rows="3" v-model="form.memo"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="open = false">取 消</el-button>
                <el-button type="primary" @click="submit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import isEmpty from '@/components/common/is-empty'
import { addEtfield, removeEtfield, updateEtfield, getEtfieldList } from '@/api/exam/etfield'
export default {
    data() {
        return {
            currentPage: 1, // 当前页数，支持 .sync 修饰符
            pageSize: 10, // 每页显示条目个数，支持 .sync 修饰符
            pagerCount: 7, // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            totalEnclosure: 0, // 总条目数
            dialogTitle: "",
            dialogVisible: false,
            activeName: "mysupervise",
            open: false,
            form: {},
            etfieldList: [
                // {
                //     fieldId: '1', // 题库id
                //     fieldName: '第一个题库', // 名称
                //     memo: '题库描述', // 描述
                //     createTime: '2019/1/8 10:10:10',
                //     questionNum: 45
                // }
            ],
            rules: {
                fieldName: [{ required: true, message: "请输入题库名称", trigger: "blur" }],
                code: [{ required: true, message: "请输入题库编号", trigger: "blur" }]
            }
        };
    },
    components: {
        isEmpty
    },
    methods: {
        tabClick (i) {
            this.activeName = i.name;
        },
        handleCommand (command, etfield) {
            let { fieldId, code, fieldName, memo } = etfield;
            switch (command) {
                case 'edit':
                    this.form = { fieldId, code, fieldName, memo };
                    this.open = true;
                    break;
                case 'del':
                    this.$confirm('此操作将永久删除该题库, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        fieldId = String(fieldId)
                        removeEtfield([fieldId]).then(() => {
                            this.$message.success('删除成功!');
                            this.getList()
                        })
                    }).catch(() => {});
                    break;
                default:
                    break;
            }
        },
        handleAddEtfield () {
            this.form = {};
            this.open = true;
        },
        submit () {
            if (this.form.fieldId) {
                // 编辑
                updateEtfield(this.form).then(() => {
                    this.$message.success('修改成功!');
                    this.form = {};
                    this.open = false;
                    this.getList()
                })
            } else {
                // 添加
                addEtfield(this.form).then(() => {
                    this.$message.success('添加成功!');
                    this.form = {};
                    this.open = false;
                    this.getList()
                })
            }
        },
        // pageSize 改变时会触发
        sizeChange (pageSize) {
            this.pageSize = pageSize
            this.getList()
        },
        // currentPage 改变时会触发
        currentChange (currentPage) {
            this.currentPage = currentPage
            this.getList()
        },
        getList () {
            let page = this.currentPage
            let limit = this.pageSize
            getEtfieldList(page, limit).then(res => {
                this.etfieldList = res.list
                this.totalEnclosure = res.totalCount
            })
        }
    },
    created () {
        this.getList()
    },
    mounted () {}
};
</script>
<style lang="less">
.supervise {
    // 当tab菜单只有一个选项时,隐藏tab菜单栏下底边
    .el-tabs__item{
        border-bottom: none;
    }
    .right-btn {
        .el-button {
            width: 112px;
            height: 36px;
            font-size: 15px;
            padding: 10px 20px 12px 12px;
        }
    }
}
</style>

<style lang="less" scoped>
.supervise {
    position: relative;
    .right-btn {
        z-index: 999;
    }
    .supervise-box {
        padding: 18px 0 12px 0;
        border-bottom: 1px solid #dcdcdc;
        .supervise-tag {
            text-align: center;
            margin-top: 30px;
            font-size: 12px;
            > span {
                padding: 2px 10px;
                font-size: 16px;
                color: #14b41e;
            }
        }
        .supervise-contant {
            div {
                font-size: 14px;
                margin-bottom: 10px;
            }
            div:nth-of-type(1) {
                font-size: 16px;
                font-weight: 600;
            }
        }
        .top {
            text-align: right;
        }
        .bottom {
            float: right;
            margin-top: 30px;
        }
    }
}
</style>


